import { Validators } from "@angular/forms";
import { CannotContainOnlySpaceValidator } from "../directives/cannot-contain-only-space-validator.directive";
import { GenericConstants } from "../constants/generic.constants";
import { VerifyAsEmailValidator } from "../directives/verify-as-email-validator.directive";

/**
 * The consistent Validator Array regarding Emails
 */
export const EmailValidators = [
    // always a required field
    Validators.required,
    // not empty validation
    CannotContainOnlySpaceValidator(),
    // Should be an Email format    
    VerifyAsEmailValidator(),
    // can never exceed length
    Validators.maxLength(GenericConstants.MaxLengthEmail)
]